export default __webpack_public_path__ + "static/media/owlMe.7267d13e.png";